module.exports = __webpack_public_path__ + "img/alflorex_packshot-2.47c38b86.png";